import React from "react";
import { observer } from "mobx-react";
import { action, makeObservable, observable } from "mobx";
import { Input, Tag, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

@observer
export class TagsList extends React.Component {
    @observable currentTag = '';

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    @action.bound setCurrentTag = (value) => this.currentTag = value;

    addTag = () => {
        const tag = this.currentTag.trim();
        if (!tag) return;
        if (this.props.tags.includes(tag)) {
            this.setCurrentTag('');
            return;
        }
        this.props.addTag(tag);
        this.setCurrentTag('');
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.addTag();
        }
    };

    render() {
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {this.props.tags.map(tag => (
                    <Tag
                        key={tag}
                        closable
                        onClose={(e) => { e.preventDefault(); this.props.removeTag(tag); }}
                        style={{ margin: 0 }}
                    >
                        {tag}
                    </Tag>
                ))}
                <Input
                    size="small"
                    value={this.currentTag}
                    onChange={({ target }) => this.setCurrentTag(target.value)}
                    onKeyDown={this.handleKeyDown}
                    onBlur={this.addTag}
                    placeholder="Add tag…"
                    prefix={<PlusOutlined style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)' }} />}
                    style={{ width: 100 }}
                />
            </div>
        );
    }
}
